/* ========================================================================
   Data Layer (GTM)
 ========================================================================== */

app.dataLayer = (function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  const init = function () {
    const gtmElements = document.querySelectorAll('[data-gtm-event]:not([data-gtm-initialized])');

    gtmElements.forEach((element) => {
      element.addEventListener('click', (event) => {
        let eventName = element.dataset.gtmEvent ? element.dataset.gtmEvent : '';

        if (eventName === '') return;
        let args = {};

        args['pageUrl'] = window.location.pathname;
        args['destinationUrl'] = element.getAttribute('href');

        if (element.dataset.pagePart) {
          args['pagePart'] = element.dataset.pagePart;
        }

        pushEvent(eventName, args);
      });

      element.dataset.gtmInitialized = true;
    });
  };

  const pushEvent = function (eventName, args) {
    if (eventName === '') return;

    args = args || {};

    let gtmEvent = { event: eventName };

    for (const key in args) {
      if (args.hasOwnProperty(key)) {
        gtmEvent[key] = args[key];
      }
    }

    // DATALAYER
    window.dataLayer.push(gtmEvent);

    if (util.debugMode) console.log(gtmEvent);
  };

  // Expose public functions and variables
  return {
    init: init,
    pushEvent: pushEvent,
  };
})();

app.dataLayer.init();
